import { tagQueryKeys } from './tagsQueryKeys.js';

const tagsQueryPredicates = {
  tag: (query, tagId) => {
    const tagKey = tagQueryKeys.tag(tagId);
    return query.queryKey[0] === tagKey[0] && query.queryKey[1] === tagKey[1];
  },
  all: (query) => {
    return query.queryKey[0] === tagQueryKeys.all()[0];
  },
  resources: (query, resourceIds) => {
    const resourceKey = tagQueryKeys.resources(resourceIds);
    if (query.queryKey[0] !== resourceKey[0]) {
      return false;
    }
    const queryResourceIds = query.queryKey[1];
    if (!Array.isArray(queryResourceIds)) {
      return false;
    }
    return resourceIds.some((resourceId) => queryResourceIds.includes(resourceId));
  },
  resourcesAll: (query) => {
    return query.queryKey[0] === tagQueryKeys.resources()[0];
  }
};

export { tagsQueryPredicates };
//# sourceMappingURL=tagsQueryPredicates.js.map
